/* tslint:disable */
/* eslint-disable */
import { exists, mapValues } from '../runtime';
import type { WarehouseInvoiceLineItem } from './WarehouseInvoiceLineItem';
import {
    WarehouseInvoiceLineItemFromJSON,
    WarehouseInvoiceLineItemToJSON,
} from './WarehouseInvoiceLineItem';

export interface WarehouseInvoice {
    id?: number;
    invoiceNumber?: string;
    warehouseCourierId: number;
    subCourierId?: number | null;
    /** Non-partner-linked courier: a CourierUser (isCourier) in the warehouse's own realm. Mutually exclusive with subCourierId. */
    subCourierUserId?: number | null;
    subscriptionId?: number;
    manifestId?: number;
    status?: string;
    warehousingTotal?: number;
    inspectionTotal?: number;
    descriptionTotal?: number;
    shippingBagTotal?: number;
    missingCodeTotal?: number;
    customsTotal?: number;
    freightTotal?: number;
    seaFreightTotal?: number;
    transportationTotal?: number;
    /**
     * Catch-all bucket for line items whose feeType has no dedicated total
     * (manual 'other' charges). Part of the subtotal — render it in every fee
     * breakdown or the breakdown will not add up to its own total.
     */
    otherTotal?: number;
    peakSurchargeTotal?: number;
    subtotal?: number;
    tax?: number;
    grandTotal?: number;
    /** Store credit applied to this bill. Amount still due = grandTotal - creditApplied. Written only by applyCredit / a void refund. */
    creditApplied?: number;
    packageCount?: number;
    totalWeight?: number;
    paymentMethod?: string;
    paymentReference?: string;
    dueDate?: Date;
    paidDate?: Date;
    sentDate?: Date;
    notes?: string;
    currency?: string;
    createdOn?: Date;
    updatedOn?: Date;
    // Computed fields
    paymentLink?: string | null;
    // Relation includes
    subCourier?: any;
    subCourierUser?: any;
    manifest?: any;
    warehouseCourier?: any;
    subscription?: any;
    lineItems?: Array<WarehouseInvoiceLineItem>;
}

export interface UnpaidInvoiceSummary {
    hasUnpaid: boolean;
    totalUnpaid: number;
    overdueCount: number;
    invoiceCount: number;
    invoices: Array<{
        id: number;
        invoiceNumber: string;
        totalAmount: number;
        dueDate: Date;
        status: string;
    }>;
}

export function instanceOfWarehouseInvoice(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "warehouseCourierId" in value;
    return isInstance;
}

export function WarehouseInvoiceFromJSON(json: any): WarehouseInvoice {
    return WarehouseInvoiceFromJSONTyped(json, false);
}

export function WarehouseInvoiceFromJSONTyped(json: any, ignoreDiscriminator: boolean): WarehouseInvoice {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'invoiceNumber': !exists(json, 'invoiceNumber') ? undefined : json['invoiceNumber'],
        'warehouseCourierId': json['warehouseCourierId'],
        'subCourierId': !exists(json, 'subCourierId') ? undefined : json['subCourierId'],
        'subCourierUserId': !exists(json, 'subCourierUserId') ? undefined : json['subCourierUserId'],
        'subscriptionId': !exists(json, 'subscriptionId') ? undefined : json['subscriptionId'],
        'manifestId': !exists(json, 'manifestId') ? undefined : json['manifestId'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'warehousingTotal': !exists(json, 'warehousingTotal') ? undefined : json['warehousingTotal'],
        'inspectionTotal': !exists(json, 'inspectionTotal') ? undefined : json['inspectionTotal'],
        'descriptionTotal': !exists(json, 'descriptionTotal') ? undefined : json['descriptionTotal'],
        'shippingBagTotal': !exists(json, 'shippingBagTotal') ? undefined : json['shippingBagTotal'],
        'missingCodeTotal': !exists(json, 'missingCodeTotal') ? undefined : json['missingCodeTotal'],
        'customsTotal': !exists(json, 'customsTotal') ? undefined : json['customsTotal'],
        'freightTotal': !exists(json, 'freightTotal') ? undefined : json['freightTotal'],
        'seaFreightTotal': !exists(json, 'seaFreightTotal') ? undefined : json['seaFreightTotal'],
        'transportationTotal': !exists(json, 'transportationTotal') ? undefined : json['transportationTotal'],
        'otherTotal': !exists(json, 'otherTotal') ? undefined : json['otherTotal'],
        'peakSurchargeTotal': !exists(json, 'peakSurchargeTotal') ? undefined : json['peakSurchargeTotal'],
        'subtotal': !exists(json, 'subtotal') ? undefined : json['subtotal'],
        'tax': !exists(json, 'tax') ? undefined : json['tax'],
        'grandTotal': !exists(json, 'grandTotal') ? undefined : json['grandTotal'],
        'creditApplied': !exists(json, 'creditApplied') ? undefined : json['creditApplied'],
        'packageCount': !exists(json, 'packageCount') ? undefined : json['packageCount'],
        'totalWeight': !exists(json, 'totalWeight') ? undefined : json['totalWeight'],
        'paymentMethod': !exists(json, 'paymentMethod') ? undefined : json['paymentMethod'],
        'paymentReference': !exists(json, 'paymentReference') ? undefined : json['paymentReference'],
        'dueDate': !exists(json, 'dueDate') ? undefined : (json['dueDate'] === null ? undefined : new Date(json['dueDate'])),
        'paidDate': !exists(json, 'paidDate') ? undefined : (json['paidDate'] === null ? undefined : new Date(json['paidDate'])),
        'sentDate': !exists(json, 'sentDate') ? undefined : (json['sentDate'] === null ? undefined : new Date(json['sentDate'])),
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'createdOn': !exists(json, 'createdOn') ? undefined : (json['createdOn'] === null ? undefined : new Date(json['createdOn'])),
        'updatedOn': !exists(json, 'updatedOn') ? undefined : (json['updatedOn'] === null ? undefined : new Date(json['updatedOn'])),
        'paymentLink': !exists(json, 'paymentLink') ? undefined : json['paymentLink'],
        'subCourier': !exists(json, 'subCourier') ? undefined : json['subCourier'],
        'subCourierUser': !exists(json, 'subCourierUser') ? undefined : json['subCourierUser'],
        'manifest': !exists(json, 'manifest') ? undefined : json['manifest'],
        'warehouseCourier': !exists(json, 'warehouseCourier') ? undefined : json['warehouseCourier'],
        'subscription': !exists(json, 'subscription') ? undefined : json['subscription'],
        'lineItems': !exists(json, 'lineItems') ? undefined : (json['lineItems'] as Array<any>).map(WarehouseInvoiceLineItemFromJSON),
    };
}

export function WarehouseInvoiceToJSON(value?: WarehouseInvoice | null): any {
    if (value === undefined) { return undefined; }
    if (value === null) { return null; }
    return {
        'id': value.id,
        'invoiceNumber': value.invoiceNumber,
        'warehouseCourierId': value.warehouseCourierId,
        'subCourierId': value.subCourierId,
        'subCourierUserId': value.subCourierUserId,
        'subscriptionId': value.subscriptionId,
        'manifestId': value.manifestId,
        'status': value.status,
        'warehousingTotal': value.warehousingTotal,
        'inspectionTotal': value.inspectionTotal,
        'descriptionTotal': value.descriptionTotal,
        'shippingBagTotal': value.shippingBagTotal,
        'missingCodeTotal': value.missingCodeTotal,
        'customsTotal': value.customsTotal,
        'freightTotal': value.freightTotal,
        'seaFreightTotal': value.seaFreightTotal,
        'transportationTotal': value.transportationTotal,
        'otherTotal': value.otherTotal,
        'peakSurchargeTotal': value.peakSurchargeTotal,
        'subtotal': value.subtotal,
        'tax': value.tax,
        'grandTotal': value.grandTotal,
        'creditApplied': value.creditApplied,
        'packageCount': value.packageCount,
        'totalWeight': value.totalWeight,
        'paymentMethod': value.paymentMethod,
        'paymentReference': value.paymentReference,
        'dueDate': value.dueDate === undefined ? undefined : (value.dueDate === null ? null : value.dueDate.toISOString()),
        'paidDate': value.paidDate === undefined ? undefined : (value.paidDate === null ? null : value.paidDate.toISOString()),
        'sentDate': value.sentDate === undefined ? undefined : (value.sentDate === null ? null : value.sentDate.toISOString()),
        'notes': value.notes,
        'currency': value.currency,
        'createdOn': value.createdOn === undefined ? undefined : (value.createdOn === null ? null : value.createdOn.toISOString()),
        'updatedOn': value.updatedOn === undefined ? undefined : (value.updatedOn === null ? null : value.updatedOn.toISOString()),
    };
}
